import styled from "@emotion/styled";

export const ReplacementLineGridWrapper = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 16
});
